import { render, staticRenderFns } from "./CleaningConfiguration.vue?vue&type=template&id=aaf5fd7c&"
import script from "./CleaningConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CleaningConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports